export class SwCascaderOptions {
    title: string;  //显示文本
    key: string;  //主键值
    isLeaf?: boolean; //最底级节点
    selected?: boolean; //选中的节点
    disabled?: boolean; //是否显示节点
    expanded?: boolean; //该节点是否展开
    data?: any={}; //该节点是否展开
    children?: SwCascaderOptions[]; //子节点
    readonly?: boolean;  //该节点是否只能展示,但不能选择
    multiple?: boolean;  //最底层节点是否多选
    checkbox?: boolean;  //所有节点是否多选
    parent?:string;  //上级数据的key值
    halfSelected?:boolean;  //半选状态--有子/孙节点被选中
    level?:number;  //级数
    readonlyFrom?:string  //如果该节点是只读,是由哪红属性设置为只读的, readonlySelfId  或是 readonlyNodeId, 为了避免这两种属性一起用的时候, 设置自身为只读之后,其子节点全部只读
}